import React from 'react'
import { MainDiv } from '../Default/MainDiv'
import { DateWiseSearch } from './DateWiseSearch'
import { DateWiseSearchWithPagination } from './DateWiseSearchWithPagination'
export const FRInOut=() =>{
  
  return (
    <>
    <MainDiv>
    {/* <MainContent/>         */}
    <DateWiseSearch />
    {/* <DateWiseSearchWithPagination /> */}
   </MainDiv> 
    </>
    
  )
}
